// extracted by mini-css-extract-plugin
module.exports = {"accountHeader":"jn","primeBadge":"kn","logout":"ln"};